import { api, ENDPOINTS } from '../config';
import { CalendarFilters, CalendarResponse, CalendarResponseData, CalendarControlParams } from './types';

/**
 * Fetch devices with optional filters
 */
export async function getCalendar(filters?: CalendarFilters): Promise<CalendarResponseData[]> {
  const response = await api.get<CalendarResponse>(ENDPOINTS.CALENDAR, {
    params: filters,
  });
  
  return response.data;
}

export async function editCalendar(calendarId: number, params?: CalendarControlParams): Promise<CalendarResponseData> {
  const response = await api.patch<CalendarResponse>(`${ENDPOINTS.CALENDAR}${calendarId}/`, {
    ...params,
  });
  
  return response.data;
}
